const IAP_DEVICE_FEATURE_CODES = {
    ILUMA_I2: 'ILUMA_I2',
    ILUMA_I5: 'ILUMA_I5',
};

export default IAP_DEVICE_FEATURE_CODES;
